import { useState, useEffect } from 'react';
import { tournamentGetLeaderboard } from '../services/api';
import { useMetadata } from '../context/MetadataContext';
import { useGlobalError } from '../context/GlobalErrorContext';

/**
 * Tournament leaderboard for LeaderboardModal.
 *
 * Loads whenever `isOpen` is true and `isOpen` or `tournamentKey` changes.
 *
 * @param {boolean} isOpen - whether the modal is open
 * @param {string} [tournamentKey] - tournament to show; the active one if omitted
 */
export const useTournamentLeaderboard = (isOpen, tournamentKey) => {
  const { getText } = useMetadata();
  const { triggerError } = useGlobalError();
  const [leaderboardData, setLeaderboardData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const loadLeaderboard = async () => {
    setIsLoading(true);
    try {
      const params = {};
      if (tournamentKey) {
        params.tournament_key = tournamentKey;
      }
      
      const response = await tournamentGetLeaderboard(params);
      setLeaderboardData(response.leaders || []);
    } catch (error) {
      console.error('Error loading leaderboard:', error);
      triggerError('high', getText('errors.request_failed'));
    } finally {
      setIsLoading(false);
    }
  };

  // Load leaderboard when modal opens
  useEffect(() => {
    if (isOpen) {
      loadLeaderboard();
    }
  }, [isOpen, tournamentKey]); // eslint-disable-line react-hooks/exhaustive-deps

  return { leaderboardData, isLoading };
};

export default useTournamentLeaderboard;
